import React from 'react'
import PersonProvider, { usePerson } from 'contexts/person'
import Loader from 'components/loader'
import SalaryPane from 'pages/people/pages/profile/panes/salary'

const MySalaryPane = ({ salt }) => {
    const { person } = usePerson()

    if(!person) {
        return <Loader />
    }

    return (
        <SalaryPane
            lookingAtMyOwnProfile={true}
            standalone={true}
            salt={salt} />
    )
}

export default props => (
    <PersonProvider id="me">
        <MySalaryPane {...props} />
    </PersonProvider>
)